/* eslint-disable no-unused-vars */
export enum TrackingKeys {
    AuthLoginRedirectStarted = 'auth:login:redirect:started',
    AuthLoginRedirectError = 'auth:login:redirect:error',
    AuthLoginHandleRedirectError = 'auth:login:handle:redirect:error',
    AuthLoginTokenSilentStarted = 'auth:login:token:silent:started',
    AuthLoginTokenSilentError = 'auth:login:token:silent:error',
    AuthLoginTokenRedirectStarted = 'auth:login:token:redirect:started',
    AuthLoginTokenRedirectError = 'auth:login:token:redirect:error',
    AuthLoginEmptyToken = 'auth:login:empty:token',
    AuthSignupXhrSuccess = 'auth:signup:xhr:success',
    AuthSignupXhrError = 'auth:signup:xhr:error',
    AuthUserXhrSuccess = 'auth:user:xhr:success',
    AuthUserXhrError = 'auth:user:xhr:error',
    AuthLoginEnded = 'auth:login:ended',
    AuthTenantXhrSuccess = 'auth:tenant:xhr:success',
    AuthTenantXhrError = 'auth:tenant:xhr:error',
    AuthSessionExpired = 'auth:session:expired',
    AuthIdleHandlerTrigger = 'auth:idlehandler:trigger',
    AuthUserBrowserConnection = 'auth:user:browser_internet:down_and_restored',
    AuthUserProfileUpdated = 'auth:user:profile:updated',
    AuthUserProfileError = 'auth:user:profile:error',
    AuthUserGetUserRolesError = 'auth:user:getUserRoles:error',
}
